/**
 * Compact curator row for a pool item stem plus metadata.
 *
 * @param options - Stem text and secondary meta line (catalog or server strings).
 * @returns **`div.qz-pool-row`**.
 */
export function createPoolRow(
  options: Readonly<{
    stem: string;
    meta: string;
  }>,
): HTMLDivElement {
  const row = document.createElement("div");
  row.className = "qz-pool-row";

  const stem = document.createElement("p");
  stem.className = "qz-pool-row__stem";
  stem.textContent = options.stem;

  const meta = document.createElement("p");
  meta.className = "qz-pool-row__meta";
  meta.textContent = options.meta;

  row.appendChild(stem);
  row.appendChild(meta);
  return row;
}
